export {findAfter} from './lib/index.js'
